export default __webpack_public_path__ + "static/media/AGCLogo.20accd1b.svg";